// Déclaration explicite de la variable globale tarteaucitron
declare const tarteaucitron: any;

// Extension de l'interface Window pour éviter les erreurs TS sur dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function setupConsentServices(): void {
  tarteaucitron.init({
    privacyUrl: '/politique-confidentialite',
    orientation: 'bottom',
    showAlertSmall: false,
    cookieslist: true,
    AcceptAllCta: true,
    DenyAllCta: true,
    highPrivacy: true,
    removeCredit: true,
  });

  tarteaucitron.services.analytics = {
    key: 'analytics',
    type: 'analytic',
    name: 'Firebase Analytics',
    uri: 'https://policies.google.com/privacy',
    needConsent: true,
    cookies: ['_ga', '_gid', '_gat'],
    js: function () {
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-E7Z1FNWJL1';
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) {
        window.dataLayer.push(args);
      }

      gtag('js', new Date());
      gtag('config', 'G-E7Z1FNWJL1');
    },
    fallback: function () {},
  };

  tarteaucitron.job = tarteaucitron.job || [];
  tarteaucitron.job.push('analytics');
}
